module.exports = __webpack_public_path__ + "static/media/CosAssessmentsHero.1582077e.png";